import { TValidator } from "../../../wizard/types";
import { ApplicationStatus } from "../../types";

export const validator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (
    values.injectedData.status === ApplicationStatus.REJECTED &&
    !values.comment?.trim()
  ) {
    errors.comment = "Comment is required";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};
